export const ReplayName = (is_deleted_in_30_days: string | number, available: boolean, family_name: string, given_name: string, user_type) => {
  if (is_deleted_in_30_days === 0) {
    if (!available) {
      return family_name + ' ' + given_name + ' ' + '[一時停止]'
    } else return family_name + ' ' + given_name
  } else if (is_deleted_in_30_days === 1 && ([1, 2].includes(user_type) || ['alumni', 'employee'].includes(user_type))) {
    return family_name + ' ' + given_name + ' ' + '[脱退済み]'
  } else if (is_deleted_in_30_days === 2 && ([1, 2].includes(user_type) || ['alumni', 'employee'].includes(user_type))) {
    return '脱退済みユーザ'
  } else {
    return family_name + ' ' + given_name
  }
}

export const ReplaceHashtag = (family_name: string, given_name: string, content: string) => {
  return content?.replaceAll('#姓#', family_name)?.replaceAll('#名#', given_name)
}

export const DisplayNamePost = (
  is_deleted_in_30_days: string | number,
  available: boolean,
  family_name: string,
  given_name: string,
  user_type: string | number,
  display_name: string,
  my_post: boolean
) => {
  if (['community_admin', 3].includes(user_type)) {
    return display_name
  }
  if ((['alumni', 2].includes(user_type) && !my_post) || (['alumni', 2, 'employee', 1].includes(user_type) && my_post && !family_name && !given_name)) {
    if (is_deleted_in_30_days === 0) {
      if (!available) {
        return display_name + ' ' + '[一時停止]'
      } else return display_name
    } else if (is_deleted_in_30_days === 1) {
      return display_name + ' ' + '[脱退済み]'
    } else if (is_deleted_in_30_days === 2) {
      return '脱退済みユーザ'
    } else {
      return display_name
    }
  }
  if (['employee', 1].includes(user_type) || (['alumni', 2].includes(user_type) && my_post && family_name && given_name)) {
    if (is_deleted_in_30_days === 0) {
      if (!available) {
        return family_name + ' ' + given_name + ' ' + '[一時停止]'
      } else return family_name + ' ' + given_name
    } else if (is_deleted_in_30_days === 1) {
      return family_name + ' ' + given_name + ' ' + '[脱退済み]'
    } else if (is_deleted_in_30_days === 2) {
      return '脱退済みユーザ'
    } else {
      return family_name + ' ' + given_name
    }
  }
}

export const DisplayNameModalLike = (
  is_deleted_in_30_days: string | number,
  available: boolean,
  family_name: string,
  given_name: string,
  user_type: string | number,
  display_name: string,
  my_like: boolean
) => {
  if (['community_admin', 3].includes(user_type)) {
    return display_name
  }
  if ((['alumni', 2].includes(user_type) && !my_like) || (['alumni', 2, 'employee', 1].includes(user_type) && my_like && !family_name && !given_name)) {
    if (is_deleted_in_30_days === 0) {
      if (!available) {
        return display_name + ' ' + '[一時停止]'
      } else return display_name
    } else if (is_deleted_in_30_days === 1) {
      return display_name + ' ' + '[脱退済み]'
    } else if (is_deleted_in_30_days === 2) {
      return '脱退済みユーザ'
    } else {
      return display_name
    }
  }
  if (['employee', 1].includes(user_type) || (['alumni', 2].includes(user_type) && my_like && family_name && given_name)) {
    if (is_deleted_in_30_days === 0) {
      if (!available) {
        return family_name + ' ' + given_name + ' ' + '[一時停止]'
      } else return family_name + ' ' + given_name
    } else if (is_deleted_in_30_days === 1) {
      return family_name + ' ' + given_name + ' ' + '[脱退済み]'
    } else if (is_deleted_in_30_days === 2) {
      return '脱退済みユーザ'
    } else {
      return family_name + ' ' + given_name
    }
  }
}

export const DisplayNameModalInterest = (
  is_deleted_in_30_days: string | number,
  available: boolean,
  family_name: string,
  given_name: string,
  user_type: string | number,
  display_name: string,
  my_interest: boolean
) => {
  if (['community_admin', 3].includes(user_type)) {
    return display_name
  }
  if ((['alumni', 2].includes(user_type) && !my_interest) || (['alumni', 2, 'employee', 1].includes(user_type) && my_interest && !family_name && !given_name)) {
    if (is_deleted_in_30_days === 0) {
      if (!available) {
        return display_name + ' ' + '[一時停止]'
      } else return display_name
    } else if (is_deleted_in_30_days === 1) {
      return display_name + ' ' + '[脱退済み]'
    } else if (is_deleted_in_30_days === 2) {
      return '脱退済みユーザ'
    } else {
      return display_name
    }
  }
  if (['employee', 1].includes(user_type) || (['alumni', 2].includes(user_type) && my_interest && family_name && given_name)) {
    if (is_deleted_in_30_days === 0) {
      if (!available) {
        return family_name + ' ' + given_name + ' ' + '[一時停止]'
      } else return family_name + ' ' + given_name
    } else if (is_deleted_in_30_days === 1) {
      return family_name + ' ' + given_name + ' ' + '[脱退済み]'
    } else if (is_deleted_in_30_days === 2) {
      return '脱退済みユーザ'
    } else {
      return family_name + ' ' + given_name
    }
  }
}

export const CountCharacter = (value: string) => {
  return value.length + value.split('\n').length - 1
}

export const CURRENCY = new Intl.NumberFormat()

export const URL_PRIVACY = 'https://www.mynavi.jp/privacy/'
export const URL_COMPANY = 'https://www.mynavi.jp/company/'
export const URL_CUSTOMER = 'https://customer-yelloop.zendesk.com/hc/ja'
export const URL_SUPPORT = 'https://support-yelloop.zendesk.com/hc/ja'
export const URL_CUSTOMER_FORGOT_PASSWORD = 'https://support-yelloop.zendesk.com/hc/ja/articles/59057354917273'

export const numberWithCommas = (x: any) => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : x
}

export const MOBILE_WIDTH = 767.98
export const ALUMNI_QUESTION_TYPE = { FREE_TEXT: 0, SINGLE_CHOICE: 1, MULTIPLE_CHOICE: 2 }
export const LIST_USER_NAME = (users: any, userMention: any) => {
  if (userMention?.data) {
    const mention_users = [...users]

    if (!mention_users.some((item) => item.id === 0)) {
      mention_users.unshift({
        id: 0,
        display_name: userMention.operating_name,
        image_url: userMention?.operating_image_url,
        user_type: 'community_admin',
      })
    }
    return mention_users
  }

  return users
}

export const HANDLE_USERS_MENTION = (usersMention: any, listUserCommunities: any) => {
  if (usersMention) {
    return usersMention.map((user) => {
      const mappedUser = listUserCommunities[user.id]
      return {
        ...user,
        display_name: mappedUser ? mappedUser.display_name : user.display_name,
      }
    })
  }
  return usersMention
}

export const MAX_STRING_DISPLAY = (text: string, maxLength: number = 15): string => {
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
}
export const NOTIFICATION_TYPE = {
  NORMAL: 1,
  TYPE: 2,
}

export const POST_TYPE = {
  DETAILS: 'details',
  LIST: 'list',
}

export const MODAL_ID = {
  INTEREST_COMPLETE: 'interestComplete',
  INTEREST_CONFIRM: 'interestConfirm',
}

export enum SNS_SITE {
  SNS_GOOGLE = 'google_oauth2',
  SNS_FACEBOOK = 'facebook',
  SNS_LINE = 'line',
}

export enum SNS_METHOD {
  CONNECT = 'connect',
  INVITE = 'invite',
  LOGIN = 'login',
}

export enum YELLOOP_CHECK_REJOIN_INTENTIONS {
  APPLY_IMMEDIATELY = 1,
  CONSIDER_IF_CONDITIONS_MATCH = 2,
  MAYBE_IN_FUTURE = 3,
  NOT_INTERESTED = 4,
}

export enum YELLOOP_CHECK_REJOIN_DESIRED_INFORMATIONS {
  COMPANY_NEWS = 1,
  COMPANY_INITIATIVES = 2,
  NETWORKING_OPPORTUNITIES = 3,
  COLLABORATION_OPPORTUNITIES = 4,
  RECRUITMENT_INFORMATION = 5,
}

export enum YELLOOP_CHECK_FOLLOW_UP_INTERVAL {
  ONE_MONTH = 1,
  THREE_MONTHS = 2,
  SIX_MONTHS = 3,
  ONE_YEAR = 4,
  NOT_FOLLOW_UP = 5,
}

export const snsConnectDefinedErrorMsg = ['ERROR_SOCIAL_ACCOUNT_LINKING', 'ERROR_SOCIAL_ACCOUNT_ALREADY_LINKING', 'ACCESS_DENIED', 'NO_AUTHORIZATION_CODE', 'ERROR_LOGIN']

export const SNS_LOGIN_URL = (snsSite: SNS_SITE) => {
  const snsMap = {
    [SNS_SITE.SNS_GOOGLE]: 'google_oauth2',
    [SNS_SITE.SNS_FACEBOOK]: 'facebook',
    [SNS_SITE.SNS_LINE]: 'line',
  }
  const snsVal = snsMap[snsSite] ?? ''
  if (!snsVal) {
    return ''
  }
  return `${process.env.VUE_APP_API_ENDPOINT}/alumnus/${snsVal}`
}

export const inquiryEmployeeSA81 = 'https://support-yelloop.zendesk.com/hc/ja/articles/51355716138393'
export const inquiryAlumniSA81 = 'https://support-yelloop.zendesk.com/hc/ja/articles/51355716138393'

export const formatUnreadCount = (count: number | string | null | undefined): string => {
  const num = Number(count)

  if (isNaN(num) || num <= 0) return ''
  if (num > 99) return '99+'

  return num.toString()
}

export const partnerChatDisplayName = (info: any, isAdmin: boolean = false) => {
  const displayName = info?.display_name ?? info?.partner_display_name
  const userType = info?.user_type ?? info?.partner_user_type

  if (!isAdmin) {
    return displayName
  }

  const { management_no, is_deleted_in_30_days, available, family_name, given_name } = info || {}

  if (userType === 'community_admin') {
    return displayName
  }

  const isValidPeriod = [0, 1].includes(is_deleted_in_30_days)

  const managementNo = isValidPeriod ? management_no : ''
  const isAlumniActive = userType === 'alumni' && isValidPeriod
  const extraDisplayName = isAlumniActive && displayName ? `（ ${displayName} ）` : ''
  const formattedName = ReplayName(is_deleted_in_30_days, available, family_name, given_name, userType)

  return [managementNo, formattedName, extraDisplayName].filter(Boolean).join(' ')
}

export enum SAAS_TYPE {
  COMMUNITY = 'community',
  POOL = 'pool',
}

export const SAAS_TYPE_VALUE: Record<SAAS_TYPE, string> = {
  [SAAS_TYPE.COMMUNITY]: 'コミュニティ型',
  [SAAS_TYPE.POOL]: 'プール型',
}

export enum FORM_TYPE {
  form_1 = 1,
  form_2 = 2,
  form_3 = 3,
}

export enum SEARCH_METHODS {
  ALL = 'all',
  ONE = 'one',
}
